import { ApplicationErrors, ApplicationErrorsType } from 'helpers/errors/applicationErrors';

// errors we don't want to display to users
export const ApplicationIgnoredErrors: readonly ApplicationErrorsType[] = [
    ApplicationErrors['no-result-found-for-slug'],
    'seo-page-not-found',
    'blog-article-access-denied',
    'store-not-found',
] as const;
